import { render, staticRenderFns } from "./Psychometrics.vue?vue&type=template&id=07934888&scoped=true&"
import script from "./Psychometrics.vue?vue&type=script&lang=js&"
export * from "./Psychometrics.vue?vue&type=script&lang=js&"
import style0 from "./Psychometrics.vue?vue&type=style&index=0&id=07934888&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07934888",
  null
  
)

export default component.exports